import moment from 'moment';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import CalendarSlot from './calendar/CalendarSlot';
import CalendarPickupEvent from './calendar/CalendarPickupEvent';
const START_HOUR = 7;
const END_HOUR = 20;

const ScheduleCalendar = ({
  currentWeek,
  setCurrentWeek,
  pickups,
  schedulePickup,
  assignDriverToPickup,
}) => {
  const [expandedSlot, setExpandedSlot] = useState(null);
  const startOfWeek = currentWeek.clone().startOf('week').add(1, 'day');

  const days = Array.from({ length: 7 }, (_, index) =>
    startOfWeek.clone().add(index, 'days'),
  );
  const hours = Array.from(
    { length: END_HOUR - START_HOUR + 1 },
    (_, i) => i + START_HOUR,
  );
  const goToPrevWeek = () => {
    setCurrentWeek((prev) => prev.clone().subtract(1, 'week'));
  };

  const goToNextWeek = () => {
    setCurrentWeek((prev) => prev.clone().add(1, 'week'));
  };

  const pickupsBySlot = pickups.reduce((acc, pickup) => {
    if (!pickup.scheduled_pickup_time) return acc;

    const date = moment(pickup.scheduled_pickup_time).format('YYYY-MM-DD');
    const hour = moment(pickup.scheduled_pickup_time).hour();

    const key = `${date}-${hour}`;

    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(pickup);

    return acc;
  }, {});

  return (
    <div
      className="card p-3"
      style={{
        flex: 1,
        borderRadius: '4px',
        height: '78vh',
        color: '#000',
        minWidth: '400px',

        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <button className="btn btn-light border" onClick={goToPrevWeek}>
          <i className="fa fa-chevron-left" />
        </button>

        <div className="text-center">
          <h3 className="fw-bold mb-0">{startOfWeek.format('MMMM YYYY')}</h3>

          <div className="text-muted small">Weekly Schedule</div>
        </div>

        <button className="btn btn-light border" onClick={goToNextWeek}>
          <i className="fa fa-chevron-right" />
        </button>
      </div>

      {/* DAYS */}
      <div
        className="calendar-scroll"
        style={{
          flex: 1,
          overflowY: 'auto',
        }}
      >
        <div
          style={{
            display: 'flex',
            // overflowX: 'auto',
            minWidth: '100%',
            minHeight: '100%',
          }}
        >
          {/* TIME COLUMN */}
          <div
            style={{
              minWidth: '80px',
              borderRight: '1px solid #e5e7eb',
              background: '#fff',
              flexShrink: 0,

              position: 'sticky',
              left: '-1px',
              zIndex: 20,
            }}
          >
            <div
              style={{
                height: '70px',
                borderBottom: '1px solid #f1f1f1',

                position: 'sticky',
                top: 0,
                left: 0,

                background: '#fff',

                zIndex: 21,
              }}
            />

            {hours.map((hour) => (
              <div
                key={hour}
                style={{
                  height: '120px',
                  padding: '8px',
                  borderBottom: '1px solid #f1f1f1',
                  fontSize: '13px',
                  color: '#6b7280',
                  fontWeight: 500,
                }}
              >
                {moment().hour(hour).minute(0).format('h A')}
              </div>
            ))}
          </div>

          {/* DAYS */}
          <div
            style={{
              display: 'flex',
              flex: 1,
              minWidth: '1200px',
              alignItems: 'stretch',
            }}
          >
            {days.map((day) => {
              const isToday = day.isSame(moment(), 'day');

              return (
                <div
                  key={day.format('YYYY-MM-DD')}
                  style={{
                    flex: 1,
                    minWidth: '180px',
                    borderRight: '1px solid #f1f1f1',
                    background: isToday ? '#add0ff' : '#fff',
                    overflow: 'hidden',
                    position: 'relative',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  {/* DAY HEADER */}
                  <div
                    style={{
                      height: '70px',
                      padding: '12px',
                      borderBottom: '1px solid #e5e7eb',
                      position: 'sticky',
                      top: 0,
                      background: isToday ? '#ddebff' : '#fff',
                      zIndex: 5,
                    }}
                  >
                    <div className="fw-bold">{day.format('dddd')}</div>

                    <div className="text-muted small">
                      {day.format('MMM DD')}
                    </div>
                  </div>

                  {/* TIME SLOTS */}
                  <div
                    style={{
                      flex: 1,
                    }}
                  >
                    {hours.map((hour) => {
                      const slotKey = `${day.format('YYYY-MM-DD')}-${hour}`;

                      return (
                        <CalendarSlot
                          day={day}
                          hour={hour}
                          isToday={isToday}
                          pickups={pickupsBySlot[slotKey] || []}
                          expanded={expandedSlot === slotKey}
                          onToggle={() =>
                            setExpandedSlot(
                              expandedSlot === slotKey ? null : slotKey,
                            )
                          }
                        />
                      );
                    })}
                  </div>

                  {/* EVENTS */}
                  {(pickupsBySlot[day.format('YYYY-MM-DD')] || []).map(
                    (pickup) => (
                      <CalendarPickupEvent
                        key={pickup.id}
                        pickup={pickup}
                        START_HOUR={START_HOUR}
                      />
                    ),
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleCalendar;
